import SmsDialog from "./sms-dialog"

export default SmsDialog

